import { socket } from "../../../redux/socket";

const DEFAULT_REPORT_ROOM_NAME = "reports";
const CREATED_CHANNEL = "reports.created";
const PATCHED_CHANNEL = "reports.patched";
const BUSINESS_SHEET_CREATED_CHANNEL = "reports.biz.created";
const BUSINESS_SHEET_DELETED_CHANNEL = "reports.biz.deleted";
const BUSINESS_SHEET_PATCHED_CHANNEL = "reports.biz.patched";

const updateBusinessSheetViewModelInCache = (updateCachedData, viewModel, isRemoved) => {
    updateCachedData((data) => {
        // lookup for the report id 
        // NOTE: business sheets are assigned to a single report and not multiple!
        // So, this bit should be fine to pickup the correct business sheet/report relationship
        let item = data.results.find(el => el.id === viewModel.reportId);
        if (item) {
            const businessSheet = isRemoved ? null : viewModel;
            const newItem = { ...item, businessSheet: businessSheet };
            Object.assign(item, newItem);
        }
    });
};

const fetchReportCacheSocketHandler = (isMasterAccountRoom) => async (props, { updateCachedData, cacheDataLoaded, cacheEntryRemoved }) => {
    const { masterAccountId } = props;
    const roomName = isMasterAccountRoom || masterAccountId ? `${masterAccountId.replace(/-/gi, '')}_reports` : DEFAULT_REPORT_ROOM_NAME;
    try {
        // this waits till the data has been cached
        await cacheDataLoaded;

        // then we subscribe to the report room to listen for changes
        socket.emit('subscribe-reports', { room: roomName });
        
        // setup an event for when the report is created
        // TODO: we will figure out how best to resolve adding to existing records later...
        socket.on(CREATED_CHANNEL, viewModel => {
            updateCachedData((data) => {
                data.newRecordsSinceCache = data.newRecordsSinceCache + 1;
            })
        });
        
        socket.on(BUSINESS_SHEET_CREATED_CHANNEL, viewModel => updateBusinessSheetViewModelInCache(updateCachedData, viewModel, false));
        socket.on(BUSINESS_SHEET_DELETED_CHANNEL, viewModel => updateBusinessSheetViewModelInCache(updateCachedData, viewModel, true));
        socket.on(BUSINESS_SHEET_PATCHED_CHANNEL, viewModel => updateBusinessSheetViewModelInCache(updateCachedData, viewModel, false));

        // setup an event for when the report is patched
        socket.on(PATCHED_CHANNEL, viewModel => {
            updateCachedData((data) => {
                let item = data.results.find(el => el.id === viewModel.id);
                if (item) {
                    Object.assign(item, viewModel)
                }
            });
        });
    }
    catch { }
    await cacheEntryRemoved;
    socket.emit('unsubscribe-reports', { room: roomName });
    socket.off(CREATED_CHANNEL);
    socket.off(PATCHED_CHANNEL);
    socket.off(BUSINESS_SHEET_CREATED_CHANNEL);
    socket.off(BUSINESS_SHEET_DELETED_CHANNEL);
    socket.off(BUSINESS_SHEET_PATCHED_CHANNEL);
};

export default fetchReportCacheSocketHandler;